import { proxy } from "valtio";

export type GoalActivationSuccessSurfaceRequest = {
  goalId: string;
  goalTitle: string;
  attemptId: string;
};

export const goalActivationSuccessSurfaceStore = proxy<{
  request?: GoalActivationSuccessSurfaceRequest;
}>({});

const shownAttempts = new Set<string>();

export function requestGoalActivationSuccessSurface(
  request: GoalActivationSuccessSurfaceRequest,
): boolean {
  if (shownAttempts.has(request.attemptId)) {
    return false;
  }
  shownAttempts.add(request.attemptId);
  goalActivationSuccessSurfaceStore.request = request;
  return true;
}

export function dismissGoalActivationSuccessSurface(): void {
  goalActivationSuccessSurfaceStore.request = undefined;
}

export function resetGoalActivationSuccessSurfaceForTest(): void {
  shownAttempts.clear();
  goalActivationSuccessSurfaceStore.request = undefined;
}
